// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__DJDMv","show":"Modal_show__4iEz4","content_wrapper":"Modal_content_wrapper__LWBV7","close_button":"Modal_close_button__4xTF9"};